import React, { useEffect, useState } from 'react';
import {
    Modal, Box, Table, TableBody, TableCell, TableContainer,
    TableHead, TableRow, CircularProgress, IconButton
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import loyaltyService from '../../services/loyaltyService';

export const LoyaltyBonusesModal = ({ open, onClose }) => {
    const [bonuses, setBonuses] = useState([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (open) {
            setLoading(true);
            loyaltyService.getLevelBonuses()
                .then(result => setBonuses(result || []))
                .catch(() => setBonuses([]))
                .finally(() => setLoading(false));
        }
    }, [open]);

    return (
        <Modal open={open} onClose={onClose}>
            <Box className="modal_body loyalty_bonuses_modal">
                <div className="loyalty_modal_title_row">
                    <span className="loyalty_modal_title">Бонусы программы лояльности</span>
                    <IconButton size="small" onClick={onClose} className="loyalty_modal_close">
                        <CloseIcon fontSize="small" />
                    </IconButton>
                </div>
                {loading ? (
                    <div className="loyalty_modal_loader">
                        <CircularProgress size={32} />
                    </div>
                ) : (
                    <TableContainer>
                        <Table size="small" className="loyalty_table">
                            <TableHead>
                                <TableRow>
                                    <TableCell>Уровень</TableCell>
                                    <TableCell>Бонусы</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {bonuses.map((bonus) => (
                                    <TableRow key={bonus.Level}>
                                        <TableCell>{bonus.Level}</TableCell>
                                        <TableCell>{bonus.Description}</TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                )}
                <div className="loyalty_modal_footer">
                    <button className="loyalty_ok_btn" onClick={onClose}>OK</button>
                </div>
            </Box>
        </Modal>
    );
};
